const buttons = document.querySelectorAll(".shop-btn");

buttons.forEach((btn) => {
  btn.addEventListener("click", function () {
    btn.classList.toggle("active");
  });
});


var productswiper = new Swiper(".productSwiperFront", {
  slidesPerView: 1,
  spaceBetween: 3,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    "@0.00": {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    "@0.60": {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    "@0.75": {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    "@1.00": {
      slidesPerView: 4.2,
      spaceBetween: 20,
    },
    "@1.50": {
      slidesPerView: 4.2,
      spaceBetween: 20,
    },
  },
});


var reelswiper = new Swiper(".reelSwiper", {
  slidesPerView: 1,
  spaceBetween: 3,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    "@0.00": {
      slidesPerView: 1.8,
      spaceBetween: 10,
    },
    "@0.75": {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    "@1.00": {
      slidesPerView: 4.2,
      spaceBetween: 20,
    },
    "@1.50": {
      slidesPerView: 4.2,
      spaceBetween: 20,
    },
  },
});